'use client';

import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import {
  COUNTRY_CODE_MX,
  COUNTRY_CODE_US,
  CountryCode,
} from '@sola/schema/dotcom/shared/geo.js';

import { usePostalMask } from '../../utils/masks';
import { usePostalPattern } from '../../utils/patterns';
import { InputField, InputFieldProps } from '../input-field/input-field';

export type PostalCodeFieldProps = InputFieldProps & {
  countryCode?: CountryCode;
  shouldValidate?: boolean;
};

export const PostalCodeField: React.FC<PostalCodeFieldProps> = ({
  countryCode = COUNTRY_CODE_US,
  shouldValidate = true,
  ...fieldProps
}) => {
  const { mask, loadMask } = usePostalMask(countryCode);
  const { pattern, loadPattern } = usePostalPattern(countryCode);
  const isUSorMX =
    countryCode === COUNTRY_CODE_US || countryCode === COUNTRY_CODE_MX;
  const { name } = fieldProps;
  const formContext = useFormContext();

  useEffect(() => {
    if (name) {
      formContext.clearErrors(name);
    }
  }, [countryCode]);

  return (
    <InputField
      inputMode={isUSorMX ? 'numeric' : 'text'}
      required={shouldValidate && isUSorMX}
      onVisible={() => {
        loadMask();
        if (shouldValidate) {
          loadPattern();
        }
      }}
      {...(!!mask && { maskOptions: mask.options })}
      pattern={shouldValidate && pattern ? { ...pattern } : undefined}
      {...fieldProps}
    />
  );
};
